<template>
<div class="odr-short__trigger odr-short__trigger_more" data-short-trigger>
    <slot></slot>
</div>
</template>

<script>
export default {}
</script>
